// extracted by mini-css-extract-plugin
export default {"dropdownButton":"Nature_dropdownButton__Xttgx"};